<!-- <p-button (onClick)="swapTheme()">Theme</p-button> -->
@if (isAuthenticated()) {
<app-layout></app-layout>
<p-dialog [(visible)]="updateDialogVisible" (onHide)="updateDialogDismissed.set(true)" [modal]="true" header="Update Available" #updateDialog> 

    <div class="flex flex-col items-center justify-center gap-4" >
        <p >A new version of Mission Control is available.  Please update to the latest version.</p>
        <p> If you do not update, you may experience issues when using the application.  Only dismiss this dialog if you have work on the current screen you need to save.</p>
       
        <div class="flex flex-row gap-2">
            <p-button label="Dismiss" variant="outlined"  (onClick)="updateDialog.close($event)"></p-button>
            <p-button label="Update" (onClick)="refreshPage()"></p-button>
        </div>
    </div>

</p-dialog>
} @else {
    <div class="overflow-y-auto h-[100svh]">
<router-outlet></router-outlet>
</div>
}

<app-image-lightbox></app-image-lightbox>
<p-toast position="top-right" key="top-right"></p-toast>
<p-toast position="bottom-right" [life]="5000"></p-toast>
<app-mc-cf-login></app-mc-cf-login>